import React ,{ useEffect } from 'react'
import FilledButton from "../../../component/FilledButton";
import { useSelector } from 'react-redux';

function CoursePayment({ onStepFinish, allOptions, formData, tokenLoading, submitLoader, dispatch }) {
    let current = allOptions?.allCourse?.filter(data => data.courseId === formData?.course_selection?.course_id)[0]; 
    const userData = useSelector((state) => state.ApplicationModel.applicatio_id);
    // useEffect(()=>{
    //     dispatch.ApplicationModel.preClgEvent({
    //       ["event"]: 'Application Step 3',
    //       email:userData.email,
    //       user_id:userData._id,
    //       course_id:userData.course_id
    //     });
    //   },[userData])
      
    return (
        <div className="course_payment">
            <div>
                <h3>You're applying for the course {current?.name}.</h3>
                <h3>Please submit your $35 application fee in order to complete your application for review.</h3>
            </div>
            <div className="form_group pt_1 pb_2">
                <FilledButton loading={tokenLoading || submitLoader} type='button' value="CONTINUE TO PAYMENT" className="btn_primary btn_primary_app ml_1" onClick={() => onStepFinish("35", 3)} />
            </div>
        </div>
    )
}

export default CoursePayment